module.exports = __webpack_public_path__ + "img/bg-tobacco.e0c4cd04.png";